<template>
  <SettingItemBox :title="$t('quickResponse') | capitalize">
    <template v-slot:content>
      <div class="filter-box">
        <div class="search-quick-response">
          <v-icon size="20" class="search-quick-response-icon">mdi-magnify</v-icon>
          <input v-model='search' type="text" autocomplete="nope" :placeholder="$t('search') | capitalize"/>
        </div>
        <div class="sort-quick-response">
          <span class="sort-label">{{ $t('sortBy') | capitalize }}:</span>
          <v-select
              v-model="sortBy"
              height="37"
              hide-details
              append-icon="mdi-chevron-down"
              solo
              flat
              :items="selectItems"
              item-text="label"
          >
            <template #selection="{item}">
              <span class="selection-txt">{{ item.label }}</span>
            </template>
          </v-select>
        </div>
        <v-btn flat small class="btn-create hidden-sm-and-down" @click="openDialogCreateQuickResponseLeader">
          <v-icon right left size="14" color="#ffff">mdi-plus-circle</v-icon>
          <span class="btn-text">{{ $t('createNew') | capitalize }}</span></v-btn>
        <v-btn flat icon class="show-on-sm-and-down hidden-md-and-up" color="#0052CC" style="margin: 0" @click="openDialogCreateQuickResponseLeader">
          <v-icon right left size="14">mdi-plus-circle</v-icon>
        </v-btn>
      </div>
      <div class="list-quick-response scroll-thin">
        <AgentQuickResponseLoading v-if="loading"/>
        <div v-else class="quick-response-item" v-for="(item, idx) of listTemplateFilters" v-bind:key="item._id" :style="`${idx === 0 ? 'border-top: 1px solid #D0D4E2': ''}`">
          <div class="list-quick-response-content">
            <ul>
              <li class="content-title">
                {{ item.title }}
              </li>
              <li class="content-desc">
                {{ item.content }}
              </li>
            </ul>
          </div>
          <div class="list-quick-response-action">
            <v-btn flat icon class="btn-edit" @click="openDialogUpdateQuickResponse(item)">
              <img src="@/assets/icons/pencil-line.svg" alt=""/>
            </v-btn>
            <v-btn flat icon class="btn-delete" @click="deleteAgentQuickResponse(item)">
              <img src="@/assets/icons/delete.svg" alt=""/>
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </SettingItemBox>
</template>

<script>
import i18n from "@/plugins/i18n";
import AgentQuickResponseLoading from "components/custom/AgentQuickResponseLoading";
import utils from "@/services/utils";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import SettingItemBox from "components/settings/SettingItemBox";

export default {
  name: "AgentQuickResponse",
  components: {SettingItemBox, AgentQuickResponseLoading},
  props: {
    botCode: String,
  },
  data() {
    return {
      search: "",
      sortBy: "time",
      selectItems: [
        {label: `${i18n.t('time')}`, value: 'time'},
        {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
      ],
    }
  },
  mounted() {
    if(this.botCode) {
      this.getAllAgentQuickResponseLeader(this.botCode)
    }
  },
  computed: {
    ...mapState('agentQuickResponse', ['loading', 'listResponseTemplateLeader']),
    listTemplateFilters: function () {
      let key = utils.removeVietnameseTones(this.search.trim().toLowerCase());
      let list = this.listResponseTemplateLeader;
      //Filter search
      if (key) {
        list = _.filter(this.listResponseTemplateLeader, (item) => {
          let _title = utils.removeVietnameseTones(item.title.toLowerCase())
          let _group = utils.removeVietnameseTones((item.group || '').toLowerCase())
          return _title.includes(key) || _group.includes(key)
        })
      }
      switch (this.sortBy) {
        case 'time':
          list = _.orderBy(list, ['created_time'], ['desc'])
          break;
        case 'often_used':
          list = _.orderBy(list, ['numberOfUses'], ['desc'])
          break;
        default:
          break;
      }
      return list
    }
  },
  methods: {
    ...mapActions('dialog', ['openDialogUpdateQuickResponse', 'openDialogCreateQuickResponseLeader']),
    ...mapActions('agentQuickResponse', ['getAllAgentQuickResponseLeader', 'deleteAgentQuickResponse']),
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.selectItems = [
          {label: `${i18n.t('time')}`, value: 'time'},
          {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
        ]
      }
    },
    botCode() {
      if (this.botCode) {
        this.getAllAgentQuickResponseLeader(this.botCode)
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../components/style/settings/settings-quick-reply";
</style>
